import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button, { ButtonProps } from '~/components/ui/Button';

import {
  SENDING_MULTISTREAM_INVITE,
  sendMultiRequest,
} from '~/modules/currentUser';
import { isLoading } from '~/modules/loading';

import { useAppDispatch, useAppSelector } from '~/hooks/redux';

interface MultistreamButtonProps {
  username: string;
}

const MultistreamButton = ({
  username,
  ...props
}: MultistreamButtonProps & ButtonProps) => {
  const dispatch = useAppDispatch();
  const invited = useAppSelector(
    (state) =>
      state.currentUser.multistream.sent.findIndex(
        (req) => req.target_stream.slug === username
      ) !== -1
  );

  const loading = useAppSelector((state) =>
    isLoading(state.loading, SENDING_MULTISTREAM_INVITE)
  );

  let label = (
    <>
      <i className="ion-person-add" />{' '}
      <FormattedMessage
        id="Multistream_Button_Invite"
        defaultMessage="Invite to multistream"
      />
    </>
  );

  if (loading) {
    label = (
      <FormattedMessage
        id="Multistream_Button_Loading"
        defaultMessage="Sending..."
      />
    );
  } else if (invited) {
    label = (
      <FormattedMessage
        id="Multistream_Button_Invited"
        defaultMessage="Invite sent"
      />
    );
  }

  return (
    <Button
      data-loading={loading}
      disabled={loading || invited}
      color="black"
      size="small"
      // @ts-expect-error
      onClick={() => dispatch(sendMultiRequest(username))}
      {...props}
    >
      {label}
    </Button>
  );
};

export default MultistreamButton;
